import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { SharedModule } from 'app/shared/shared.module';
import { FullWidthLayoutComponent } from 'app/layout/layouts/full-width/full-width.component';

@NgModule({
    declarations: [
        FullWidthLayoutComponent
    ],
    imports     : [
        RouterModule,
        FuseLoadingBarModule,
        SharedModule,
        FuseLoadingBarModule,
    ],
    exports     : [
        FullWidthLayoutComponent
    ]
})
export class FullWidthLayoutModule
{
}
